import * as ActionTypes from "./ActionTypes";
import axios from "axios";

export const setPromotions = info => {
	return {
		type: ActionTypes.LOAD_PROMOTIONS,
		promotions: info.data
	};
};

export const loadPromotions = () => {
	return dispatch => {
		axios
			.get("http://190.105.227.203/solanasapi/promociones")
			.then(response => {
				dispatch(setPromotions(response.data));
			})
			.catch(error => {});
	};
};

export const savePromotions = (promotion, token) => {
	return dispatch => {
		axios
			.update(
				"http://190.105.227.203/solanasapi/promociones/",
				promotion
			)
			.then(response => {
				dispatch(loadPromotions());
			})
			.catch(error => {});
	};
};

export const createPromotion = (promotion, token, imageUrl) => {
	return dispatch => {
		axios
			.post(
				"http://190.105.227.203/solanasapi/promociones/",
				{
					titulo: promotion.titulo,
					descripcion: promotion.descripcion,
					orden: promotion.orden,
					image: imageUrl
				}
			)
			.then(response => {
				dispatch(loadPromotions());
			})
			.catch(error => {});
	};
};

export const uploadImageAndCreatePromotion = (promotion, token) => {
	const formData = new FormData();
	formData.append("myImage", promotion.image);
	const config = {
		headers: {
			"content-type": "multipart/form-data"
		}
	};
	return dispatch => {
		axios
			.post(
				"http://190.105.227.203/solanasapi/promociones/imageupload",
				formData,
				config
			)
			.then(response => {
				dispatch(createPromotion(promotion, token, response.data));
			})
			.catch(error => {
				alert("Ocurrio al subir la imágen seleccionada. Error: " + error);
			});
	};
};

export const uploadImageAndEditPromotion = (promotion, token) => {
	const formData = new FormData();
	formData.append("myImage", promotion.image);
	const config = {
		headers: {
			"content-type": "multipart/form-data"
		}
	};
	return dispatch => {
		axios
			.post(
				"http://190.105.227.203/solanasapi/promociones/imageupload",
				formData,
				config
			)
			.then(response => {
				dispatch(editPromotion(promotion, token, response.data));
			})
			.catch(error => {
				alert("Ocurrio al subir la imágen seleccionada. Error: " + error);
			});
	};
};

export const editPromotion = (promotion, token, imageUrl) => {
	return dispatch => {
		axios
			.post(
				"http://190.105.227.203/solanasapi/promociones/edit/",
				{
					titulo: promotion.titulo,
					descripcion: promotion.descripcion,
					image: imageUrl,
					id: promotion.id
				}
			)
			.then(response => {
				dispatch(loadPromotions());
			})
			.catch(error => {});
	};
};

export const editPromotionNoImage = (promotion, token) => {

	console.log(promotion.titulo + ", " + promotion.descripcion + ", " + promotion.id);

	return dispatch => {
		axios
			.post(
				"http://190.105.227.203/solanasapi/promociones/editnoimage/",
				{
					titulo: promotion.titulo,
					descripcion: promotion.descripcion,
					id: promotion.id
				}
			)
			.then(response => {
				dispatch(loadPromotions());
			})
			.catch(error => {});
	};
};

export const deletePromotion = (promotion, token) => {
	return dispatch => {

		axios
			.delete(
				"http://190.105.227.203/solanasapi/promociones/" +
					promotion.id,
				{ data: promotion }
			)
			.then(response => {
				dispatch(loadPromotions());
			})
			.catch(error => {});
	};
};
